<template>
  <el-aside width="200px">
    <el-menu
      class="menu__wrap el-menu-vertical-demo"
      router
      active-text-color="#30C3B1"
      :default-active="$route.path"
      :collapse="isCollapse"
      :unique-opened="true"
    >
      <el-menu-item
        v-for="(item, index) in routes"
        :key="index"
        :index="item.path"
        :class="
          item.path === isActive ? 'menu-item-box active' : 'menu-item-box'
        "
      >
        <div class="menu-item">
          <!-- <i class="el-icon-menu"></i> -->
          <div @click="handleItem(item, index)">
            <el-image
              class="menu-icon"
              style="width: 20px; height: 20px; margin-right: 10px"
              :src="item.meta.icon"
              fit="cover"
            ></el-image>
            <span
              slot="title"
              :class="{
                badge:
                  (item.path == '/finance' && isb) ||
                  (item.path == '/order' && isb1) ||
                  (item.path == '/company' && isb2) ||
                  (item.path == '/report' && isb3) ||
                  (item.path == '/feedback' && isb4),
              }"
            >
              {{ item.meta.title }}</span
            >
          </div>
        </div>
      </el-menu-item>
    </el-menu>
  </el-aside>
</template>

<script>
import { remove, getStorage } from "@/storage/index.js";
export default {
  name: "LayoutNaviBar",
  props: ["isCollapse"],
  data() {
    return {
      isActive: "",
      routes: [],
      isb: false,
      isb1: false,
      isb2: false,
      isb3: false,
      isb4: false,
    };
  },
  mounted() {
    this.filterRoutes();
    this.getMsg();
  },
  watch: {
    $route(to) {
      this.isActive = to.path;
      this.getMsg();
    }
  },
  methods: {
    filterRoutes() {
      const roleType = getStorage('roleType') || 1;
      const allRoutes = this.$router.options.routes.slice(
        2,
        this.$router.options.routes.length - 1
      );
      this.routes = allRoutes.filter(route => {
        if (!route.meta || !route.meta.roles) {
          return true;
        }
        return route.meta.roles.includes(roleType);
      });
    },
    getMsg() {
      this.$http.post("/admin/notice/new", {}).then((res) =>{
        if (res.code === 1) {
          this.isb =
            res.data.withdraw_unread  ||
            res.data.allowance_unread  ||
            res.data.company_withdraw_unread ||
            res.data.auth_withdraw_unread  ;
          this.isb1 = res.data.earnest_unread == 1 || res.data.vip_unread == 1;
          this.isb2 = res.data.company_unread == 1;
          this.isb3 = res.data.report_unread == 1;
          this.isb4 = res.data.feedback_unread == 1;
        }
      })
    },
    handleItem(item, index) {
      console.log(item.path);
      if(getStorage('roleType') != 1){
        return
      }
      // this.$http.post("/admin/notice/new", {}).then((res) => {
      //   if (res.code === 1) {
      //     this.isb =
      //       res.data.withdraw_unread  ||
      //       res.data.allowance_unread  ||
      //       res.data.company_withdraw_unread ||
      //       res.data.auth_withdraw_unread  ;
      //     this.isb1 = res.data.earnest_unread == 1 || res.data.vip_unread == 1;
      //     this.isb2 = res.data.company_unread == 1;
      //     this.isb3 = res.data.report_unread == 1;
      //     this.isb4 = res.data.feedback_unread == 1;
      //     if (item.path === "/finance") {
      //       this.isb = false;
      //     }
      //     if (item.path === "/order") {
      //       this.isb1 = false;
      //     }
      //     if (item.path === "/company") {
      //       this.isb2 = false;
      //     }
      //     if (item.path === "/report") {
      //       this.isb3 = false;
      //     }
      //     if (item.path === "/feedback") {
      //       this.isb4 = false;
      //     }
      //   }
      // });
      console.log(this.$router.path);
      this.isActive = item.path;
      remove("companyStatus");
      remove("schoolPage");
    },
  },
  created() {
    this.isActive = this.$route.path;
    this.filterRoutes();
    if(getStorage('roleType') == 1) {
      this.$http.post("/admin/notice/new", {}).then((res) => {
      if (res.code === 1) {
        this.isb =
          res.data.withdraw_unread == 1 ||
          res.data.allowance_unread == 1 ||
          res.data.company_withdraw_unread == 1;
        this.isb1 = res.data.earnest_unread == 1 || res.data.vip_unread == 1;
        this.isb2 = res.data.company_unread == 1;
        this.isb3 = res.data.report_unread == 1;
        this.isb4 = res.data.feedback_unread == 1;
      }
    });
    }
  },
};
</script>
<style scoped lang="scss">
.menu__wrap .active {
  background: rgba(48, 195, 177, 0.1);
}
.menu__wrap {
  height: 100%;
  box-sizing: border-box;
  &::v-deep {
    .el-menu-item-group__title {
      display: none;
    }
    .el-menu-item i {
      color: #4f9a96;
    }
    .el-menu-item {
      color: #4f9a96;
    }
    .el-menu-item:hover {
      box-shadow: #eee;
    }
  }

  .menu-item-box {
    padding: 0 10px;
  }
  .el-menu-item:hover {
    background: rgba(48, 195, 177, 0.1);
  }
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
  overflow: auto;
}
.badge::after {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f56c6c;
  margin-left: 10px;
}
</style>
